// tslint:disable:max-line-length
import { Component, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SelectItem } from "primeng/primeng";

import { BASE_CONSTANTS, BASE_URLS, TCITenantSelectorType } from "@tci/common";
import { Subscription } from "rxjs";
import { NgToastrService } from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { ITCICEnvToolsComponentOutput, ITCIEnvToolsComponentInput } from "../../ng-tenant/tci-tenant-components";
import { BaseTibcliDownloadService } from "./base-tibcli-download.service";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";

@Component({
    selector: TCITenantSelectorType.TCI_ENV_TOOLS_DLD_TIBCLI.toString(),
    templateUrl: "./base-tibcli-download.component.html",
    // Note: multiple css file in styleUrls MUST keep it in one line, otherwise sourcemap will be in disorder when debug in browser.
    styleUrls: ["./base-tibcli-download.component.less"]
})
export class BaseTibcliDownloadComponent
    extends AbstractTCITenantComponent <EventEmitter<string>, ITCIEnvToolsComponentInput, ITCICEnvToolsComponentOutput<any>>
    implements OnInit, OnDestroy {

    private subscriptions: Subscription[] = [];
    isPreparingDownload = false;
    loadingText = "Preparing download...";
    OSes: SelectItem[];
    selectedOS: SelectItem = null;
    tibcliVersion: { name: string, version: string, date: string } = null;
    dropdownStyles = {
        "background-color": "#1774E5",
        "border": "none",
        "height": "40px",
        "line-height": "24px",
        "vertical-align": "middle",
        "width": "341px",
        "text-align": "middle",
        "font-size:": "16px"
    };

    constructor(
        private translate: TranslateService,
        private toastr: NgToastrService,
        private baseTibcliDownload: BaseTibcliDownloadService
    ) {
        super();
    }

    ngOnInit(): void {
        this
            .subscriptions
            .push(
                this
                    .baseTibcliDownload
                    .getProductVersion()
                    .subscribe(
                        data => {
                            if (data) {
                                this.tibcliVersion = data;
                            }
                        },
                        error => {
                            console.log("Error getting the product version: ", error);
                        }
                    ),
                this
                    .translate
                    .get([
                        "NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.MAC_VERSION",
                        "NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.WINDOWS_VERSION",
                        "NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.LINUX_VERSION"
                    ])
                    .subscribe(
                        data => {
                            this.OSes = [
                                {
                                    label: data["NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.MAC_VERSION"],
                                    value: "mac"
                                },
                                {
                                    label: data["NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.WINDOWS_VERSION"],
                                    value: "windows"
                                },
                                {
                                    label: data["NG_ENV_TOOLS.TIBCLI_DOWNLOAD_BUTTON_CAPTION.LINUX_VERSION"],
                                    value: "linux"
                                }
                            ];
                        },
                        error => {
                            console.log("Error getting translations for Tibcli OSes: ", error);
                        }
                    )
            );
    }

    ngOnDestroy(): void {
        this
            .subscriptions
            .forEach((subscription: Subscription) => subscription.unsubscribe());
    }

    public formatDate(dateTimeString) {
        return new Date(dateTimeString.replace(/UTC/, "Z"));
    }

    public download(): void {
        if (this.selectedOS) {
            const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TOOLS}/cli`;

            this.isPreparingDownload = true;
            this
                .subscriptions
                .push(
                    this
                        .baseTibcliDownload
                        .download(url, this.selectedOS.toString(), "amd64")
                        .subscribe(
                            () => {
                                this.isPreparingDownload = false;
                            },
                            error => {
                                console.log(error);
                                this.toastr.error("Failed to download Tibcli tool.");
                            }
                        )
                );
        }
    }
}
